import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import UserService from 'services/UserService';

import * as UserActionTypes from 'actiontypes/user';
import { bootstrap } from 'actions/app';
import handleAccessCodeResult from './handleAccessCodeResult';
import createBootstrapOptions from 'actions/user/createBootstrapOptions';

const service = new UserService();

/** ----------------------------------------------------------------------------
 * LOGIN - login a user
 -----------------------------------------------------------------------------*/
export default function loginUser(creds, location, history) {
  return async (dispatch, getState) => {
    dispatch(loginRequested());

    const state = getState();
    const { accessCodes: { accessCode } } = state;
    const accessCodeName = accessCode.name;

    try {
      const { data } = await service.login({ ...creds, accessCodeName });
      dispatch(loginSuccess(data));
      dispatch(bootstrap(createBootstrapOptions(dispatch)));
      history.push(location.state ? location.state.from : '/');
      // Handle access code result
      dispatch(handleAccessCodeResult(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(loginFailure(error));
    }
  };
}

const loginRequested = () => ({ type: UserActionTypes.LOGIN_REQUESTED });

export const loginSuccess = data => ({
  type: UserActionTypes.LOGIN_SUCCESS,
  isFetching: false,
  payload: {
    accessCodeResult: data.accessCodeResult,
    hasCharacter: data.hasCharacter,
    loggedIn: data.isSuccess,
    user: data.user,
    privilegeLevel: data.privilegeLevel,
  },
});

export const loginFailure = () => ({
  type: UserActionTypes.LOGIN_FAILURE,
  isFetching: false,
  loggedIn: false,
  loginError: true,
});